import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { lossPreventionRoutes } from './routes/lp.routes';
import { publicRoutes } from './routes/public.routes';
import { securedRoutes } from './routes/secured.routes';
import { sharedRoutes } from './routes/shared.routes';

const routes: Routes = [
  {
    path: '',
    children: [...publicRoutes, ...securedRoutes, ...lossPreventionRoutes, ...sharedRoutes, { path: '**', redirectTo: 'home' }],
  },
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(routes, {
  bindToComponentInputs: true,
  enableTracing: false,
});
